import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { darkModeClass } from '../../utils/cn';
import styles from './Skills.module.css';

const Skills = () => {
  const { isDarkMode } = useTheme();
  const { data, t, formatNumber } = useLanguage();
  const skillsData = data.skills;

  return (
    <section id="skills" className={`${styles.skills} ${darkModeClass(styles, isDarkMode)}`}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>{t('skills.title')}</h2>
          <p className={styles.sectionSubtitle}>{t('skills.subtitle')}</p>
        </div>
        
        <div className={styles.skillsContainer}>
          {skillsData.map((skillCategory, index) => (
            <div key={index} className={styles.skillCategory}>
              <h3 className={styles.categoryTitle}>
                <i className={skillCategory.icon}></i> {skillCategory.category}
              </h3>
              
              <div className={styles.skillsGrid}>
                {skillCategory.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className={styles.skillItem}>
                    <div className={styles.skillHeader}>
                      <div className={styles.skillIcon}>
                        <i className={skill.icon}></i>
                      </div>
                      <span className={styles.skillName}>{skill.name}</span>
                    </div>
                    
                    <div className={styles.skillLevelBar}>
                      <div 
                        className={styles.skillLevelFill} 
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                    
                    <span className={styles.skillLevelText}>{formatNumber(skill.level)}%</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(Skills);